import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const FAQs10 = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: 'How do I place an order?',
            answer: 'Browse our collection, add items to your cart, and proceed to checkout. You will need to create an account or sign in to complete your purchase.',
        },
        {
            question: 'What is your return policy?',
            answer: 'We accept returns within 14 days of delivery. Items must be unworn, unwashed, and in their original packaging. Please contact us to initiate a return.',
        },
        {
            question: 'How long does shipping take?',
            answer: 'Standard shipping takes 5-7 business days within India. Express shipping is available at checkout for 2-3 business day delivery.',
        },
        {
            question: 'Do you offer international shipping?',
            answer: 'We currently ship within India. International shipping is coming soon. Subscribe to our newsletter to be the first to know.',
        },
        {
            question: 'Are your products handmade?',
            answer: 'Yes. Every STHIR piece is handcrafted by skilled artisans across India. We work with traditional weaving and printing communities to create each garment.',
        },
        {
            question: 'How do I care for my garments?',
            answer: 'We recommend dry cleaning for silk pieces and gentle hand wash for cotton and linen. Each garment comes with specific care instructions on the label.',
        },
        {
            question: 'Can I modify or cancel my order?',
            answer: 'Orders can be modified or cancelled within 2 hours of placement. After this window, orders enter our artisan production pipeline. Please contact us immediately for any changes.',
        },
        {
            question: 'Do you offer custom sizing?',
            answer: 'We offer standard sizing from S to XL. For custom sizing requests, please reach out to us via our contact page and we will work with our artisans to accommodate your needs.',
        },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <p className="text-[#A8A29E] text-[10px] md:text-xs tracking-[3px] uppercase mb-3">Support</p>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">Frequently Asked Questions</h1>
                    </div>

                    <div className="max-w-[700px] mx-auto px-5 md:px-8 py-8 md:py-14">
                        <div className="space-y-0">
                            {faqs.map((faq, index) => (
                                <div
                                    key={index}
                                    style={{ borderBottom: '1px solid #E7E5E4' }}
                                >
                                    <button
                                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                        className="w-full flex justify-between items-center py-5 text-left bg-transparent border-none cursor-pointer"
                                    >
                                        <span className="text-[#1C1917] text-sm font-light pr-4">{faq.question}</span>
                                        <ChevronDown
                                            className={`w-4 h-4 text-[#A8A29E] flex-shrink-0 transition-transform duration-300 ${
                                                openIndex === index ? 'rotate-180' : ''
                                            }`}
                                            strokeWidth={1.5}
                                        />
                                    </button>
                                    <div
                                        className={`overflow-hidden transition-all duration-300 ${
                                            openIndex === index ? 'max-h-48 pb-5' : 'max-h-0'
                                        }`}
                                    >
                                        <p className="text-[#78716C] text-sm font-light leading-relaxed">
                                            {faq.answer}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default FAQs10;
